import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { windowService } from '../utils/window.utils';

const getQuery = () => new URLSearchParams(windowService().location?.search);

const getQueryStringVal = (key: string): string | null => getQuery().get(key);

const useQueryParams = (
  key: string,
  defaultVal: string
): [string, (val: string) => void] => {
  const navigate = useNavigate();
  const [query, setQuery] = useState(getQueryStringVal(key) || defaultVal);

  const updateUrl = (newVal: string) => {
    setQuery(newVal);

    const query = getQuery();

    if (newVal.trim() !== '') {
      query.set(key, newVal);
    } else {
      query.delete(key);
    }

    navigate(`?${query.toString()}`);
  };

  return [query, updateUrl];
};
export default useQueryParams;
